/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_4Inputs */



/**
* | output |
* | --- |
* | "Use of the feature for purposes beyond the described service scope" |
*
* @param {Guardrails_Section_4_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_4 = /** @type {((inputs?: Guardrails_Section_4_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwendung der Funktion für Zwecke, die über die beschriebene Leistungsbeschreibung hinausgehen")
	return /** @type {LocalizedString} */ ("Use of the feature for purposes beyond the described service scope")
});